import request from "@/utils/request"

//分页查询全部  画册
export function listPage(data) {
  return request({
    url: '/h5PictureAlbum/listPage',
    method: 'get',
    params: data
  })
}